export default "__VITE_ASSET__j2A7Uo4l__"